// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__qv8Eg","container":"footer_container__e7adL","desc":"footer_desc__QElbV","link-grid":"footer_link-grid__-ViFR","social-grid":"footer_social-grid__IDHeJ"};